import styles from './styles.module.scss';

type InputCheckboxProps = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
};

export function InputCheckbox({
    label,
    checked,
    onChange,
    disabled = false,
}: InputCheckboxProps) {
    return (
        <label className={styles.container}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(e) => onChange(e.target.checked)}
            />

            <span className={styles.checkmark} />

            <span className={styles.label}>{label}</span>
        </label>
    );
}
